import React, { useState, useRef,useEffect } from 'react';
import {
  Edit, Create, SimpleForm, TextInput, ReferenceInput,
  AutocompleteInput, DateInput, BooleanInput, Button,
  SelectInput, required, FileInput, FileField
} from 'react-admin';
import * as apiClient from "../../common/apiClient";
import CreateToolbar from "../../common/PopupCreateToolbar";
import {
  useParams
} from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import AlertDialog from './Dialog';
import { toast } from 'react-toastify';
import { serviceChannelUploadEditColumnDef } from './common';
import { CSVLink, CSVDownload } from "react-csv";

export const ModuleEdit = props => {
  const gridRef = useRef<any>();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");
  const [gridColumns, setGridColumns] = useState<any[]>(serviceChannelUploadEditColumnDef);
  const [result, setResult] = useState<any[]>([]);
  const [clear, setClear] = useState(false)
  const [confirm, setConfirm] = useState(false)

  const getImportUploadLogs = () => {
    apiClient.getImportDetails(props.id).then(res => {
      //console.log(res, "====RES=====");
      let data  = [...res];
      
      setResult(data);
    }).catch(err => {

    });
  }
 
  const onCancel = () => {
    props.history.goBack();
  }
  useEffect(() => {
    if(!props.id) return;
    getImportUploadLogs();
  }, [props.id]);
  return (
    <>
      {isProcessing && (
        <div className='page-loader-container'>
          <div className='loader'>Loading...</div>
        </div>
      )}
      {<div className='errormessage'>{error}</div>}
      {<div
        className="ag-theme-balham box-shadow"
        style={{
          padding: '0px 24px',
          height: 'calc(100vh - 135px)',
          width: '100%'
        }}
      >
        <AgGridReact
          columnDefs={gridColumns}
          ref={gridRef}
          rowData={result}>
        </AgGridReact>
        {<div className='upload-actions'>
          <Button
            variant="contained" color="primary"
            size="medium"
            label="Back"
            onClick={() => {
              props.history.push("/update-ord-servchannels");
              
            }}
          />
          {result.length > 0 && <CSVLink filename={"importReportData.csv"} data={result}>Download Import File</CSVLink>}
        </div>}
      </div>}

    </>
  );
}